import { useModal } from '@shared/model/useModal';

export const useHowWorkReferralModal = () => useModal('how-work-referral-modal')